/**
 * Generic CSV string builders and browser download helpers.
 */

/**
 * Escape a single CSV field, quoting when the value contains separators.
 *
 * @param {*} value Cell value.
 * @returns {string} Escaped CSV field.
 */
export function escapeCsvField(value) {
  const text = value == null ? "" : String(value);
  if (/[",\r\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

/**
 * Build a CSV document from headers and row arrays.
 *
 * @param {Array<string>} headers Column headers in display order.
 * @param {Array<Array<*>>} rows Cell values aligned to `headers`.
 * @returns {string} CSV text with CRLF line endings.
 */
export function buildCsvString(headers, rows) {
  const lines = [
    headers.map(escapeCsvField).join(","),
    ...rows.map((row) => row.map(escapeCsvField).join(",")),
  ];
  return lines.join("\r\n");
}

/**
 * Trigger a browser download of CSV text.
 *
 * @param {string} filename Suggested download filename.
 * @param {string} csvText CSV document body. A UTF-8 BOM is prepended for Excel.
 * @returns {void}
 */
export function downloadCsv(filename, csvText) {
  const blob = new Blob([`\uFEFF${csvText}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
